<template>
  <v-card width="100%" class="modern-card" elevation="0">
    <apexchart height="400px" type="pie" :options="chartOptions" :series="chartSeries"></apexchart>
  </v-card>
</template>

<script>
export default {
  props: {
    title_header: {
      type: String,
      default: "Título del Gráfico",
    },
    data: {
      type: Object,
      default: () => ({
        label: [],
        series: [],
      }),
      required: true,
    },
  },
  data() {
    return {
      colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'],
    };
  },
  computed: {
    chartSeries() {
      return this.data.series;
    },
    chartOptions() {
      return {
        chart: {
          type: 'pie',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const label = config.w.config.labels[config.dataPointIndex];
              const value = config.w.config.series[config.dataPointIndex];
              this.$emit('selection', { label, value });
            }
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
        },
        title: {
          text: this.title_header,
          align: 'center',
          style: {
            fontSize: '22px',
            fontWeight: 'bold',
            fontFamily: 'Roboto, sans-serif',
            color: '#333',
          },
        },
        labels: this.data.label,
        colors: this.colors,
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -5
            }
          }
        },
        dataLabels: {
          formatter(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, val.toFixed(1) + '%'];
          },
          style: {
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 'bold',
          },
          background: {
            enabled: true,
            foreColor: '#000',
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.7,
          },
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 1,
            left: 1,
            blur: 1,
            opacity: 0.45
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px',
          fontFamily: 'Roboto, sans-serif',
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: '#fff',
            fillColors: undefined,
            radius: 12,
          },
          itemMargin: {
            horizontal: 5,
            vertical: 5
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value.toFixed(1) + '%';
            }
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 280
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      };
    }
  },
  watch: {
    data: {
      handler: function (newValue) {
        this.$nextTick(() => {
          if (this.$refs.chart) {
            this.$refs.chart.updateOptions({
              labels: newValue.label,
            });
            this.$refs.chart.updateSeries(newValue.series);
          }
        });
      },
      deep: true,
      immediate: true
    }
  },
};
</script>

<style scoped>
.modern-card {
  background-color: #FFFFFF !important;
  border-radius: 16px !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
  padding: 16px;
}

:deep(.apexcharts-legend-text) {
  font-family: 'Roboto', sans-serif !important;
}

:deep(.apexcharts-title-text) {
  font-family: 'Roboto', sans-serif !important;
}
</style>